import JSZip from 'jszip';
import { Service } from '../modules/nodesCanvasModule/components/storeClasses/service';

import { toCamelCase } from '@/modules/globalModule/components/helperMethods';
import { PackageT } from '@/modules/nodesCanvasModule/components/storeClasses/packageT';
import { V4UUID } from '@/firebase/database';
import { generateFieldString } from './msgFileGen';

export function createSrvFiles(
  zip: JSZip,
  workspaceId: V4UUID,
  pkg: PackageT
): void {
  const srvFolder: JSZip = zip.folder('srv')!;
  pkg.services.forEach((service: Service) => {
    srvFolder.file(
      `${toCamelCase(service.name)}.srv`,
      getSrvText(service, pkg, workspaceId)
    );
  });
}

export function getSrvText(srv: Service, pkg: PackageT, workspaceId: V4UUID) {
  let srvText: string = '';
  for (let req of srv.requestList) {
    srvText += generateFieldString(req, workspaceId, pkg.id);
  }
  srvText += '# add custom requests below\n';
  srvText += srv.customText.requestText;
  srvText += '\n---\n';
  for (let res of srv.responseList) {
    srvText += generateFieldString(res, workspaceId, pkg.id);
  }
  srvText += '# add custom responses below\n';
  srvText += srv.customText.responseText;
  return srvText;
}
